export default "__VITE_ASSET__DLcH20Uq__"